import { useEffect, useRef, useState } from 'react';
import { Menu } from './lib/components/Menu';
import { PageHealthyTan } from './pages/PageHealthyTan';
import { Landingpage } from './pages/Landingpage';
import { PageCampaign } from './pages/PageCampaign';
import { PageTips } from './pages/PageTips';
import { PageUVindex } from './pages/PageUVindex';
import { PageImprint } from './pages/PageImprint';
import { PageDetails } from './pages/PageDetails';
import { TopCover } from './assets/styles/menuStyles';
import { Page, PageNames, Location} from './assets/ts/customTypes';
import { PageLocations } from './pages/PageLocations';
import { defaultLocation } from './assets/ts/locations';
import { PageSponsors } from './pages/PageSponsors';
import { CoordsPopUp } from './assets/styles/generalStyles';

export function App() {
    const [uvIndex, setUvIndex] = useState<number>();
    const [isTimerGo, setIsTimerGo] = useState(false);
    const [needTopCover, setNeedTopCover] = useState(false);
    const [coordsVisible, setCoordsVisible] = useState(false);
    const [wasFadeTriggered, setWasFadeTriggered] = useState(false);
    const [secondsToContentPage, setSecondsToContentPage] = useState(3);
    const [currentLocation, setCurrentLocation] = useState<Location | false >(false);
    const [currentPage, setCurrentPage] = useState<Page>({ name: PageNames.LANDING, page: <Landingpage />});
    const FadeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (secondsToContentPage <= 0 && currentLocation !== false) setNextPage(PageNames.INDEX)
        else if (secondsToContentPage <= 0 && currentLocation === false) transitionToContent({ locationType: 'city' });
    }, [currentLocation, secondsToContentPage, uvIndex]);

    useEffect(() => {
        const lowerCaseUrl = window.location.pathname.toLowerCase();
        if (lowerCaseUrl.includes('/qr/liste')) {
            transitionToContent({ locationType: 'city' });
            setSecondsToContentPage(0);
            return;
        }
        else if (lowerCaseUrl.includes('/qr/standort') && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setCurrentLocation({
                        'Ihr Standort': {
                            lat: position.coords.latitude,
                            long: position.coords.longitude,
                        }
                    });
                },
                (error) => { setCurrentLocation(false)},
            );
        }
        else if (navigator.geolocation) {
            console.log(navigator.geolocation);
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setCurrentLocation(
                        {
                            'Ihr Standort': {
                                lat: position.coords.latitude,
                                long: position.coords.longitude,
                            }
                        });
                },
                (error) => { setCurrentLocation(false);},
            );
        }
        else {
            setCurrentLocation({
                'Ihr Standort': {
                    lat: defaultLocation[0].lat,
                    long: defaultLocation[0].long,
                }
            });
        }
        setIsTimerGo(true);
    }, []);

    useEffect(() => {
        (async () => {
            fetch('/track.php', {
                credentials: 'same-origin',
            });
            let indexRes;

            if (currentLocation !== false) {
                indexRes = await fetch('/get-uv-index.php', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        lat: Object.values(currentLocation)[0].lat,
                        long: Object.values(currentLocation)[0].long,
                        name: Object.keys(currentLocation)[0],
                    }),
                });
            }
            if (indexRes !== undefined && indexRes.ok) {
                const indexJson: { ok: boolean; index: number; name: string } = await indexRes.json();
                if (indexJson.ok) {
                    handleSettingUvValue(indexJson.index);
                }
            } else {
                setCurrentLocation(false);
            }
        })();
    }, [currentLocation]);

    useEffect(() => {
        let resetInterval = setInterval(() => {
            if (secondsToContentPage > 0 && isTimerGo) {
                setSecondsToContentPage(secondsToContentPage - 1);
            }
            if (secondsToContentPage <= 2 && !wasFadeTriggered && currentLocation !== undefined) {
                transitionToContent({ locationType: 'live' });
            } else if (secondsToContentPage <= 2 && !wasFadeTriggered && currentLocation === undefined) {
                transitionToContent({ locationType: 'city' });
            }
        }, 1000);
        return () => {
            clearInterval(resetInterval);
        };
    }, [secondsToContentPage, isTimerGo]);

    function transitionToContent({ locationType }: { locationType: 'live' | 'city' }) {

        if (locationType === 'city') {
            setCurrentPage({
                name: PageNames.LOCATIONS,
                page: <PageLocations uvIndex={uvIndex} setUvIndex={handleSettingUvValue} setCurrentLocation={setCurrentLocation} />,
            });
        }
        else if (locationType === 'live' && uvIndex !== undefined) {
            setCurrentPage({
                name: PageNames.INDEX,
                page: (
                    <PageUVindex
                        setNextPage={setNextPage}
                        isNavigationInstant={true}
                        uvIndex={uvIndex}
                        showCoords={showCoords}
                        currentLocation={currentLocation ? currentLocation : defaultLocation}
                    />
                ),
            });
        }
        else {
            setCurrentPage({
                name: PageNames.LOCATIONS,
                page: <PageLocations uvIndex={uvIndex} setUvIndex={handleSettingUvValue} setCurrentLocation={setCurrentLocation} />,
            });
        }
        triggerFade();
    }

    function setNextPage(nextPage: PageNames) {
        switch (nextPage) {
            case PageNames.INDEX:
                setNeedTopCover(false);
                if (currentPage.name === PageNames.INDEX) {
                    document.getElementById('UV-' + Math.round(uvIndex ? uvIndex : 0))?.scrollIntoView({ block: 'start', behavior: 'smooth' });
                } else {
                    setCurrentPage({
                        name: PageNames.INDEX,
                        page: (
                            <PageUVindex
                                setNextPage={setNextPage}
                                isNavigationInstant={true}
                                uvIndex={uvIndex ? uvIndex : 0}
                                showCoords={showCoords}
                                currentLocation={currentLocation ? currentLocation : defaultLocation}
                            />
                        ),
                    });
                }
                break;
            case PageNames.TAN:
                setCurrentPage({ name: PageNames.TAN, page: <PageHealthyTan /> });
                setNeedTopCover(true);
                break;
            case PageNames.CAMPAIGN:
                setCurrentPage({ name: PageNames.CAMPAIGN, page: <PageCampaign /> });
                setNeedTopCover(true);
                break;
            case PageNames.TIPS:
                setCurrentPage({ name: PageNames.TIPS, page: <PageTips /> });
                setNeedTopCover(true);
                break;
            case PageNames.IMPRINT:
                setCurrentPage({ name: PageNames.IMPRINT, page: <PageImprint /> });
                setNeedTopCover(true);
                break;
            case PageNames.LOCATIONS:
                setCurrentPage({
                    name: PageNames.LOCATIONS,
                    page: <PageLocations uvIndex={uvIndex} setUvIndex={handleSettingUvValue} setCurrentLocation={setCurrentLocation}/>,
                });
                setNeedTopCover(true);
                break;
            case PageNames.DETAILS:
                setCurrentPage({ name: PageNames.DETAILS, page: <PageDetails />, });
                break;
            case PageNames.SPONSORS:
                setCurrentPage({ name: PageNames.SPONSORS, page: <PageSponsors />, });
                break;
            default:
                setSecondsToContentPage(3);
                setCurrentPage({ name: PageNames.LANDING, page: <Landingpage /> });
                break;
        }
    }
    function triggerFade() {
        if (FadeRef.current && !wasFadeTriggered) {
            FadeRef.current.className = 'fadeInAnimation';
        }
        setWasFadeTriggered(true);
    }

    function handleSettingUvValue(newUvIndex: number) {
        setUvIndex(newUvIndex < 1 ? 1 : newUvIndex);
    }

    function showCoords() {
        setCoordsVisible(true);
        setTimeout(() => {
            setCoordsVisible(false);
        }, 5000);
    }

    return (
        <>
            {secondsToContentPage > 0 && <Landingpage/>}
            <div style={{ opacity: 0 }} ref={FadeRef}>
                {needTopCover && <TopCover />}
                <Menu setNextPage={setNextPage} uvIndex={uvIndex} currentPage={currentPage.name} />
                {currentPage.page}
                <CoordsPopUp
                    onClick={(e) => navigator.clipboard.writeText(e.currentTarget.innerHTML)}
                    coordsVisible={coordsVisible}
                >
                    {currentLocation !== false ? Object.values(currentLocation)[0].lat + ' ' + Object.values(currentLocation)[0].long : ''}
                </CoordsPopUp>
            </div>
        </>
    );
}
